"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var Text_1 = require("../Text");
var styles_1 = __importDefault(require("./styles"));
var Tag = function (_a) {
    var text = _a.text, _b = _a.canDelete, canDelete = _b === void 0 ? false : _b, rest = __rest(_a, ["text", "canDelete"]);
    var classes = (0, styles_1.default)({ canDelete: canDelete });
    return ((0, jsx_runtime_1.jsx)(core_1.Chip, __assign({ className: classes.root }, rest, { deleteIcon: (0, jsx_runtime_1.jsx)(icons_1.ClearRounded, { "data-testid": "delete-chip-icon", color: "inherit", height: "12", width: "12" }), label: (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ size: "small", weight: "extra-bold", color: "inherit" }, { children: text.toUpperCase() })) })));
};
exports.Tag = Tag;
